import type { ColumnDef } from "@tanstack/vue-table";
import Checkbox from "../../checkbox/Checkbox";

export const TableSelection = <T,>(): ColumnDef<T> => {
  return {
    id: "selection",
    enableHiding: false,
    enableSorting: false,
    size: 1,
    meta: {
      freeze: "left",
    },
    header: ({ table }) => {
      return (
        <Checkbox
          class="gap-0"
          modelValue={table.getIsAllPageRowsSelected()}
          onUpdate:modelValue={(value) => {
            table.toggleAllPageRowsSelected(!!value);
          }}
          indeterminate={table.getIsSomePageRowsSelected()}
        />
      );
    },
    cell: ({ row }) => {
      return (
        <Checkbox
          class="flex gap-0"
          modelValue={row.getIsSelected()}
          onUpdate:modelValue={(value) => row.toggleSelected(!!value)}
        />
      );
    },
  };
};
